export default "__VITE_ASSET__DFLiBlg8__"